"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WHOS_ORGANISATIONS_OPTIONS = exports.ORGANISATION_TYPE_OPTIONS = void 0;

var _filterFunctions = require("../utils/filterFunctions");

var ORGANISATION_TYPE_OPTIONS = [{
  label: 'ALL ORGANISATIONS',
  value: _filterFunctions.ORGANISATION_TYPE_FILTER_MAP.ALL
}, {
  label: 'DRAFT ONLY',
  value: _filterFunctions.ORGANISATION_TYPE_FILTER_MAP.DRAFT
}, {
  label: 'NEW ONLY',
  value: _filterFunctions.ORGANISATION_TYPE_FILTER_MAP.NEW
}, {
  label: 'ACTIVE ONLY',
  value: _filterFunctions.ORGANISATION_TYPE_FILTER_MAP.ACTIVE
}, {
  label: 'AT-RISK ONLY',
  value: _filterFunctions.ORGANISATION_TYPE_FILTER_MAP.RISK
}];
exports.ORGANISATION_TYPE_OPTIONS = ORGANISATION_TYPE_OPTIONS;
var WHOS_ORGANISATIONS_OPTIONS = [{
  label: 'EVERYONE\'S ORGANISATIONS',
  value: _filterFunctions.WHOS_ORGANISATIONS_FILTER_MAP.EVERYONE
}, {
  label: 'ONLY MY ORGANISATIONS',
  value: _filterFunctions.WHOS_ORGANISATIONS_FILTER_MAP.MINE
}];
exports.WHOS_ORGANISATIONS_OPTIONS = WHOS_ORGANISATIONS_OPTIONS;